import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const BoatRepair = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my boat repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps boat repair businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for boat repair businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most boat repair businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my boat repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like boat repair. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Boat Repair - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Boat Repair CRM", url: "/industries/boat-repair" }
  ];

  const industryData = {
    name: 'Boat Repair & Marine Service',
    title: 'Capture Pre-Season Rush & Build Year-Round Maintenance Revenue',
    subtitle: 'Never miss urgent repair calls, automate seasonal reminders, and manage complex marine service projects',
    icon: '⛵',
    challenges: [
      'Overwhelmed during spring prep season',
      'Boat owners forget winterization',
      'Emergency repairs interrupt schedule',
      'Hard to track complex multi-day jobs',
      'Parts ordering delays projects'
    ],
    solutions: [
      'Pre-season booking automation',
      'Winterization reminder campaigns',
      'Emergency call capture',
      'Project management tracking',
      'Parts inventory automation'
    ],
    features: [
      'Customer CRM with boat profiles',
      'Seasonal service reminders',
      'Emergency repair booking',
      'Multi-day project tracking',
      'Parts ordering integration',
      'Slip/storage management',
      'Before/after documentation',
      'Review automation'
    ],
    results: [
      'Book 3 months in advance',
      '90% winterization completion',
      'Consistent year-round revenue',
      '£8.4K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Boat Repair UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for boat repair businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for boat repair UK, boat repair business software, boat repair customer management, boat repair lead generation UK"
        url="/industries/boat-repair"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default BoatRepair;